/* eslint-disable react/prop-types */
import { Box, Modal, Typography } from "@mui/material";
import SoftButton from "components/SoftButton";
import SwitchBox from "components/SwitchBox";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: 1,
  p: 1,
};

function Button({ children, ...rest }) {
  return (
    <button
      style={{
        padding: "4px 10px",
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

const Actions = ({ list, pickAll, date, setDate, setPickAll, handleChangeSwitch }) => {
  const [open, setOpen] = React.useState(false);
  const [isDate, setIsDate] = React.useState(0);

  const handleClose = () => {
    setOpen(false);
  };
  const handleSuccess = () => {
    setDate(isDate);
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        minWidth: 300,
        zIndex: 1,
        border: "1px solid black",
        background: "#fff",
        display: "flex",
        gap: 5,
        padding: 4,
      }}
    >
      {/* <Button onClick={() => setOpen(true)}>Thêm phụ lục</Button> */}
      <Button onClick={() => setOpen(true)}>Chọn lại ngày</Button>
      <Button>Nhập lại</Button>
      <Button>Ghi</Button>
      <Button>In</Button>
      <Button>Xóa</Button>
      <Button>Kết xuất</Button>
      <Button>Nhập từ XML</Button>
      <Button>Đóng</Button>

      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              p: 1,
              border: "1px solid black",
              borderRadius: 1,
              mt: 1,
            }}
          >
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Chọn ngày được nhận cổ tức, lợi nhuận
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  time_24hr: true,
                  dateFormat: "d-m-Y",
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
                onChange={(e) => setIsDate(new Date(e[0]).getTime())}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              mt: 2,
            }}
          >
            <SoftButton onClick={handleSuccess} color="dark">
              Đồng ý
            </SoftButton>
            <SoftButton onClick={handleClose} color="secondary">
              Đóng
            </SoftButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Actions;
